import { render, staticRenderFns } from "./LandPracticesTable.vue?vue&type=template&id=5f6f8fea&scoped=true&"
import script from "./LandPracticesTable.vue?vue&type=script&lang=js&"
export * from "./LandPracticesTable.vue?vue&type=script&lang=js&"
import style0 from "./LandPracticesTable.vue?vue&type=style&index=0&id=5f6f8fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f8fea",
  null
  
)

export default component.exports